export default "__VITE_ASSET__C02s6sXP__"